export default theme => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    justifyContent: 'space-between'
  },
  left: {
    height: '100%',
    display: 'flex',
    flexGrow: 1
  },
  right: {
    marginRight: '16px'
  },
  field: {
    marginRight: 8
  },
  views: {},
  viewsAlone: {
    marginRight: 8
  },
  viewsChip: {
    maxWidth: 156
  },
  viewsChipFilled: {
    '& [class*="Text"]': {
      display: 'inline-block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 'calc(100% - 16px)'
    }
  },
  clearContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  actionsClear: {
    marginLeft: 16,
    cursor: 'pointer',
    color: theme.colors.actionMajor[500],
    transition: 'all 0.15s ease',
    '&:hover': {
      color: theme.colors.actionMajor[600]
    }
  },
  actionsClearDisabled: {
    marginLeft: 8,
    cursor: 'default',
    color: theme.colors.utility.textDisabled,
    pointerEvents: 'none'
  },
  selectFuzzy: {
    '& [class*="inputWrapper"]': {
      paddingTop: 0,
      paddingBottom: 0
    }
  },
  selectWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  singleSelected: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 100
  },
  divider: {
    width: 2,
    height: 16,
    margin: '0px 8px',
    backgroundColor: theme.colors.grey[100],
    flexShrink: 0
  },
  popoverCustomWide: {
    '& .hoi-poi-popover-inner': {
      width: 340
    },
    '& .hoi-poi-select__menu': {
      boxShadow: 'none !important',
      paddingBottom: 0,
      margin: 0
    }
  },
  fieldGroupDivider: {
    height: 'auto',
    alignSelf: 'center'
  },
  fieldGroupRangeWrapper: {
    marginTop: 0
  },
  hr: {
    display: 'block',
    height: 1,
    border: 'none',
    backgroundColor: theme.colors.grey[100],
    margin: '12px -12px'
  },
  advancedFilter: {
    marginBottom: 12
  },
  subFilters: {
    borderTop: `1px solid ${theme.colors.grey[100]}`,
    marginTop: 16,
    padding: 0,
    '& [class*="FiltersContent__filter"]': {
      marginBottom: 0
    },
    '& [class*="Section__root"]': {
      paddingRight: 0
    },
    '& $field > * + *': {
      marginTop: 12
    }
  },
  subFiltersActions: {
    paddingTop: 8
  },
  addButton: {
    marginLeft: '16px'
  },
  addButtonIcon: {
    width: '32px',
    height: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: '16px',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: theme.colors.grey[50]
    }
  }
});